import React, { useState, useEffect } from "react"
import Nav from "./nav"
import "../sass/mystyles.scss"

const HamburgerMenu = ({ theme }) => {
  const [open, setOpen] = useState(false)

  // if the esc key is pressed close the toggles
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (keyCode !== 27) return
      setOpen(false)
    }
    document.addEventListener("keydown", keyHandler)

    return () => document.removeEventListener("keydown", keyHandler)
  })

  return (
    <div className="level-right">
      <div
        className="menu-wrap is-inline-block has-text-white pointer-event level-item"
        data-target="navbar"
      >
        <input
          type="checkbox"
          className="toggler"
          onChange={() => setOpen(!open)}
          checked={open}
        />
        <div className="hamburger">
          <div className={open === true ? "light" : theme}></div>
        </div>
        <div
          className={open === true ? "menu is-visible" : "menu is-invisible"}
          onClick={() => setOpen(false)}
          onKeyDown={() => setOpen(false)}
          role="button"
          aria-hidden="true"
        >
          <div>
            <div>
              <Nav />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HamburgerMenu
